// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-amp-index-tsx": function componentSrcPagesAmpIndexTsx() {
    return import("./../../src/pages/amp/index.tsx"
    /* webpackChunkName: "component---src-pages-amp-index-tsx" */
    );
  },
  "component---src-pages-blog-index-jsx": function componentSrcPagesBlogIndexJsx() {
    return import("./../../src/pages/blog/index.jsx"
    /* webpackChunkName: "component---src-pages-blog-index-jsx" */
    );
  },
  "component---src-pages-contactsuccess-js": function componentSrcPagesContactsuccessJs() {
    return import("./../../src/pages/contactsuccess.js"
    /* webpackChunkName: "component---src-pages-contactsuccess-js" */
    );
  },
  "component---src-pages-index-tsx": function componentSrcPagesIndexTsx() {
    return import("./../../src/pages/index.tsx"
    /* webpackChunkName: "component---src-pages-index-tsx" */
    );
  },
  "component---src-pages-karaoke-static-index-jsx": function componentSrcPagesKaraokeStaticIndexJsx() {
    return import("./../../src/pages/karaoke-static/index.jsx"
    /* webpackChunkName: "component---src-pages-karaoke-static-index-jsx" */
    );
  },
  "component---src-templates-about-page-amp-js": function componentSrcTemplatesAboutPageAmpJs() {
    return import("./../../src/templates/about-page.amp.js"
    /* webpackChunkName: "component---src-templates-about-page-amp-js" */
    );
  },
  "component---src-templates-about-page-js": function componentSrcTemplatesAboutPageJs() {
    return import("./../../src/templates/about-page.js"
    /* webpackChunkName: "component---src-templates-about-page-js" */
    );
  },
  "component---src-templates-blog-post-amp-js": function componentSrcTemplatesBlogPostAmpJs() {
    return import("./../../src/templates/blog-post.amp.js"
    /* webpackChunkName: "component---src-templates-blog-post-amp-js" */
    );
  },
  "component---src-templates-blog-post-js": function componentSrcTemplatesBlogPostJs() {
    return import("./../../src/templates/blog-post.js"
    /* webpackChunkName: "component---src-templates-blog-post-js" */
    );
  },
  "component---src-templates-contact-page-amp-js": function componentSrcTemplatesContactPageAmpJs() {
    return import("./../../src/templates/contact-page.amp.js"
    /* webpackChunkName: "component---src-templates-contact-page-amp-js" */
    );
  },
  "component---src-templates-contact-page-js": function componentSrcTemplatesContactPageJs() {
    return import("./../../src/templates/contact-page.js"
    /* webpackChunkName: "component---src-templates-contact-page-js" */
    );
  },
  "component---src-templates-karaoke-page-amp-js": function componentSrcTemplatesKaraokePageAmpJs() {
    return import("./../../src/templates/karaoke-page.amp.js"
    /* webpackChunkName: "component---src-templates-karaoke-page-amp-js" */
    );
  },
  "component---src-templates-karaoke-page-js": function componentSrcTemplatesKaraokePageJs() {
    return import("./../../src/templates/karaoke-page.js"
    /* webpackChunkName: "component---src-templates-karaoke-page-js" */
    );
  },
  "component---src-templates-tags-js": function componentSrcTemplatesTagsJs() {
    return import("./../../src/templates/tags.js"
    /* webpackChunkName: "component---src-templates-tags-js" */
    );
  }
};